import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addConsume, upConsume, trueUpConsume } from "@/api/financial/consumptionDetails";
import { serchSelect, serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    var _this = this;

    var validateNum = function validateNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入消耗金额'));
      } else {
        if (!/^[1-9]\d*$/.test(value)) {
          callback(new Error('不能输入0或者小数点'));
        }

        callback();
      }
    };

    return {
      pickerOptions0: {
        //限制时间不能超过此时
        disabledDate: function disabledDate(time) {
          if (_this.searchData.date != "") {
            return time.getTime() > Date.now() || time.getTime() > _this.searchData.date;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      dialogFormVisible: false,
      searchData: {
        id: "",
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        ad_channel: '',
        ad_placement: '',
        date: "",
        amount: "",
        country: '',
        special_product_id: ''
      },
      isDisplay: false,
      rules: {
        special_product_id: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        game: [{
          required: true,
          message: "游戏",
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: "平台",
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: "渠道",
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: "包名",
          trigger: "blur"
        }],
        date: [{
          required: true,
          message: "日期",
          trigger: "blur"
        }],
        amount: [{
          required: true,
          validator: validateNum,
          trigger: "blur"
        }] // country: [{ required: true, message: "选择国家", trigger: "blur" }],

      },
      formLabelWidth: "80px",
      adPlacementSingleChoice: true,
      issubstitution: false
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$upConsume, data, ProductData, ds, k;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;
                _this2.isDisplay = row ? true : false;
                _this2.searchData.id = '';

                if (!row) {
                  _context.next = 20;
                  break;
                }

                _context.next = 6;
                return upConsume({
                  id: row.id
                });

              case 6:
                _yield$upConsume = _context.sent;
                data = _yield$upConsume.data;
                _context.next = 10;
                return _this2.searchProductData(row);

              case 10:
                ProductData = _context.sent;
                row.product_id = ProductData.id;
                _context.next = 14;
                return _this2.getAdvPlarform({
                  special_product_id: row.product_id
                });

              case 14:
                _this2.searchData.ad_channel = data.ad_channel;
                _context.next = 17;
                return _this2.advChannelchange(data.ad_channel);

              case 17:
                ds = {};

                for (k in _this2.searchData) {
                  ds[k] = data[k] ? data[k] : '';
                }

                _this2.searchData = _this2.processingData(_objectSpread(_objectSpread({}, ds), {}, {
                  special_product_id: row.product_id
                }));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this3.searchData.id ? trueUpConsume : addConsume;
          var searchData = JSON.parse(JSON.stringify(_this3.searchData));
          req(searchData).then(function (res) {
            if (res.status == 200) {
              Message.success('操作成功');

              _this3.$emit("refreshDataList");

              _this3.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        game: this.searchData.game,
        platform: this.searchData.platform,
        channel: this.searchData.channel,
        pkg: this.searchData.pkg,
        date: "",
        amount: "",
        country: '',
        ad_channel: '',
        ad_placement: '',
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id
      };

      if (this.rawData.game_show_type == 1) {
        this.advchannels = [];
      }

      this.advLocation = [];
      this.$refs.ruleForm.resetFields();
    }
  }
};